var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container-fluid"},[_c('MenuRock'),_c('br'),_c('router-view'),_c('br'),_c('FooterRock')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }